module.exports = __webpack_public_path__ + "static/joc_03-4ab478b333f3629ad9f586cdeb8bbe88.jpg";